import Blob from "cross-blob";

export const videoTranscriptFileUrl = (videoTranscript) => {
  if (videoTranscript && videoTranscript.stream === "") {
    return videoTranscript.link && videoTranscript.link.href
      ? videoTranscript.link.href
      : "";
  }
  let blob = new Blob([videoTranscript.stream]);
  if (typeof window !== "undefined" && localStorage) {
    return window.URL.createObjectURL(blob);
  }
  return "";
};

export const videoTranscriptFileExtension = (extension) => {
  if (extension) {
    if (extension[0] === ".") {
      return extension;
    }
    return "." + extension;
  }
  return "";
};
